
import axios from "axios";
import { ENV, getDomainHeader } from "../env";

const axiosInstance = axios.create({
  baseURL: ENV.baseURL,
});

// Add a request interceptor to attach the token and domain
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }

  config.headers["Domain"] = getDomainHeader("");
  return config;
});

export default axiosInstance;

